import { gql, type TypedDocumentNode } from "@apollo/client";
import { type GQL } from "@binale-tech/shared";

/**
 * Company saldo-transfer GraphQL operations. Shared across layers - consumed by the
 * company drawer (@app) and the accounting toolbar's year-end saldo transfer
 * (@accounting/shared/GenericTableShell). Lives in @domain so neither feature reaches
 * across into the other (the toolbar previously imported this from the @app drawer).
 */
const fragmentSaldo = gql`
    fragment CompanyTransferSaldoFragment on CompanyTransferSaldoResult {
        id
        yearTo
        userId
        createdAt
        er {
            id
            productId
            groupId
            saldo
        }
        erAnz {
            id
            productId
            groupId
            saldo
        }
        deb {
            id
            productId
            groupId
            saldo
        }
        bank {
            id
            productId
            groupId
            saldo
        }
        kb {
            id
            productId
            groupId
            saldo
        }
    }
`;

export const companyTransferSaldo: TypedDocumentNode<
    Pick<GQL.IMutation, "companyTransferSaldo">,
    GQL.IMutationCompanyTransferSaldoArgs
> = gql`
    ${fragmentSaldo}
    mutation companyTransferSaldo($input: CompanyTransferSaldoInput!) {
        companyTransferSaldo(input: $input) {
            ...CompanyTransferSaldoFragment
        }
    }
`;

export const companyTransferSaldoLogs: TypedDocumentNode<
    Pick<GQL.IQuery, "companyTransferSaldoLogs">,
    GQL.IQueryCompanyTransferSaldoLogsArgs
> = gql`
    ${fragmentSaldo}
    query companyTransferSaldoLogs($companyId: ID!, $yearTo: Int!) {
        companyTransferSaldoLogs(companyId: $companyId, yearTo: $yearTo) {
            ...CompanyTransferSaldoFragment
        }
    }
`;
